import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Upload } from 'lucide-react'
import { ImportScreen } from '@/screens/connect/SCR-187-import'

export const Route = createFileRoute('/_app/connect/import')({
  staticData: { screen: { id: 'SCR-187', title: 'Import memories', group: 'Connect', perm: ['key.manage', 'connector.manage'], order: 4, eyebrow: 'Bring what you already know', description: 'Move facts in from JSONL, CSV, Markdown or a ChatGPT or Claude export. Check every row first; undo within 24 hours.', icon: Upload } },
  validateSearch: z.object({ import: z.string().max(100).optional().catch(undefined) }),
  component: ImportScreen,
})
